import utils from "../../../utils/utils.js";


export default {
    async fetchBrands(context, payload) {

        const params = utils.utility.checkQueryParams(payload.params);

        const responseData = await utils.utility.fetch(`api/Setting/GetTrademarks?${params.toString()}`, "GET", null, null);

        context.commit("setBrands", responseData.data);
    },
    async fetchBrandDetailById(context, payload) {
        const params = utils.utility.checkQueryParams(payload.params);

        const responseData = await utils.utility.fetch(`api/Setting/GetTrademarkDetailById?${params.toString()}`, "GET", null, null);

        context.commit("setBrandById", responseData.data);
    },
    async deleteBrand(context, payload) {
        const requestBody = {
            trademarkId: payload.id,
        }

        await utils.utility.fetch(
            `api/Setting/DeleteTrademark`,
            "POST",
            null,
            requestBody
        );        
    },
    async fetchProducts(context, payload) {
        
        const params = utils.utility.checkQueryParams(payload.params);

        const responseData = await utils.utility.fetch(`api/Setting/GetProducts?${params.toString()}`, "GET", null, null);

        context.commit("setProducts", responseData.data);
    },    
    async fetchProductDetailById(context, payload) {
        const params = utils.utility.checkQueryParams(payload.params);
      
        const responseData = await utils.utility.fetch(`api/Setting/GetProductDetailById?${params.toString()}`, "GET", null, null);

        context.commit("setProductById", responseData.data);
    },
    async deleteProduct(context, payload) {
        const requestBody = {
            ebReportId: payload.id,
        }
        await utils.utility.fetch(
            `api/Setting/DeleteProduct`,
            "POST",
            null,
            requestBody
        );   
    }
}